import React from 'react'
import EbookData from '../ebook.json'
import ServerInfo from '../server.json'
import '../App.css';
import {
    CardSection,
}from '../common'
import BottomBar from '../common/BottomBar'
import HeaderBar from '../common/HeaderBar'
import ShowBooks from '../common/ShowBooks'
import {connect } from 'react-redux'
import axios from 'axios'


class Search extends React.Component {
    
    state = {
        isIframeOpen: false,
        epubIframeLink: 'epub_content/epubfile',
        ipAddress: ServerInfo.ipAddress,
        searchBookArray: [],
        seacrhInput: '',
        resultFound: ''
    };

    styles = {
        fontSize: 20,
        fontWeight: "bold",
        borderWidth: 20,
    }

    

    /*constructor(){
        super();
        this.handleIncrement = this.handleIncrement.bind(this);
    }*/
    componentDidMount()
    {
        var bookTitle = this.props.match.params.text
        this.findBooks(bookTitle)
    }

    render() {

        return(
            <div>                 
            <HeaderBar history={this.props.history}></HeaderBar>

            <div style={{padding: '40px 10px 100px', minWidth:"320px"}}>
                <CardSection style={{flexDirection: 'column', }}>
                <div style={this.titlePageContainer}>
                    <div>
                        <h1 style={{marginBottom: 5}}>Search Book</h1>
                        <p style={{fontWeight: 600, color: 'grey', marginTop: 0, marginBottom: 25}}>Find your next favorite book</p>
                    </div>                   
                </div>
                <div style={this.inputDiv}>
                    <input style={this.input} placeholder="Search.." type="text" onChange={this.updateSearchInput} />
                    <button onClick={() => this.findBooks(this.state.seacrhInput)} style={this.searchButton}>SEARCH</button>
                </div>
                </CardSection>

                <p>{this.state.resultFound}</p>

                <ShowBooks
                bookArray = {this.state.searchBookArray}
                libraryProps = {this.props}/>
                
            </div>
            <BottomBar history={this.props.history}></BottomBar>
            </div>
        )
        
    }

    findBooks = (keyword) =>
    {
        if(keyword == 'allbooks')
        {
            keyword = ''
        }
        var tempBookArray = []
        var noOfBookFound = 0
        for(var i=0; i<EbookData.length; i++)
        {
            var tempTitle = EbookData[i].title
            var tempCategory = EbookData[i].category
            tempTitle = tempTitle.toUpperCase()
            tempCategory = tempCategory.toUpperCase()
            if(tempTitle.includes(keyword.toUpperCase()) || tempCategory.includes(keyword.toUpperCase()))
            {
                tempBookArray.push(EbookData[i])
                noOfBookFound++
            }
        }
        this.setState({ searchBookArray : tempBookArray })
        this.setState({ resultFound: noOfBookFound + ' result(s) found for "' + keyword + '"'})

        //
        // var self = this
        // var bodyFormData = new FormData();
        // bodyFormData.append("mainId", 149);
        // bodyFormData.append("title", keyword);
        // bodyFormData.append("type", "EPUB");

        // axios({
        //     method: 'post',
        //     url: 'http://localhost:8080/content/SearchContent',
        //     data: bodyFormData,
        //     config: {headers: {
        //         "Content-Type": "multipart/form-data"}
        //         }
        // })
        // .then(response => {
        //     console.log(response.data)
        //     noOfBookFound = response.data.length
        //     self.setState({
        //         searchBookArray : response.data,
        //         resultFound: noOfBookFound + ' result(s) found for "' + keyword + '"'
        //     })
        // })
        // .catch(error => {
        //     console.log(error)
        // })
    }

    updateSearchInput= (event) =>
    {
        this.setState({seacrhInput: event.target.value})
    }

    //Styles
    closeBtn = {
        fontSize: 20,
        padding: 10,
        margin: 'auto'
    }

    selection = {
        color: 'black',
        padding: '15px 25px 15px 0px',
        display: 'inline-block',
        fontSize: '16px',
        cursor: 'pointer',
        fontWeight: 650,
    }

    categoryName = 
    {
        fontSize: '18px',
        fontWeight: 600,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        padding: 0,
        margin: 0,
    }
    
    titlePageContainer =
    {
        height: 116,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    }

    bookArrangement =
    {
        display: 'flex',
        flexWrap: 'wrap',
        whiteSpace: 'nowrap',
        justifyContent: 'center',
    }

    searchButton =
    {
        height: '100%',
        borderRadius: '0 4px 4px 0',
        border: '1px solid grey',
        backgroundColor: 'light-grey',
        padding: 11,
        fontWeight: 500,
        fontSize: 15,
    }
        
    searchIcon = 
    {
        height: '2.5em',
        width: '2.5em',
        filter: 'brightness(0) invert(1)',
    }
    inputDiv =
    {
        display: 'flex',
        flexDirection: 'row',
        padding: '0 20px',
    }
    input=
    {
        fontSize: 15,
        height: '2.5em',
        width: '100%',
        borderRadius: '4px 0px 0px 4px',
        border: '1px solid grey',
        padding: '1px 10px',
    }
}

export default connect(state => state)(Search)